<template>
  <div class="home-detail-info-one">
    <slot name="header-one"/>
    <div class="home-detail-info-one-text">
      <slot name="text-one"/>
      <slot name="image"/>
  </div>
  <slot name="header-two"/>
  <div class="home-detail-info-one-text">
    <slot name="text-two"/>
  </div>
</div>
</template>

<script>
export default {
}
</script>
<style>
.home-detail-info-one {
  display: flex;
  flex-direction: column;
  padding: 20px;
  font-style: italic;
  /* background-color: red; */
  /* height: 100%; */
}
.home-detail-info-one-text {
  display: flex;
  flex-direction: column;
  /* align-items: center */
}
</style>
